import { useAuth } from '@src/main/shared/context/AuthContext';
import { FC, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface PermissionRouteProps {
  permission: string;
  children: ReactNode;
}

export const PermissionRoute: FC<PermissionRouteProps> = ({ permission, children }) => {
  const { hasPermission, user } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!hasPermission(permission)) {
    // TODO: Unauthorized page or error
    return <>Unauthorized</>;
  }

  return <>{children}</>;
};
